import type { Permissions, UserType } from './types';

/**
 * Default permissions for each user type.
 *
 * Currently empty - permissions will be defined as features are built.
 * In production, permissions may come from Salesforce via postMessage
 * or from retailer configuration.
 *
 * @example
 * // Full example of what this might look like when populated:
 * export const DEFAULT_PERMISSIONS: Record<UserType, Permissions> = {
 *   customer: {
 *     'claim.view': true,
 *     'claim.create': true,
 *     'claim.update': false,
 *     'order.view': true,
 *     'customer.view': false,    // Can't see other customer info
 *     'validation.bypass': false,
 *   },
 *   agent: {
 *     'claim.view': true,
 *     'claim.create': true,
 *     'claim.update': true,      // Agents can edit claims
 *     'order.view': true,
 *     'customer.view': true,     // Agents can see customer details
 *     'validation.bypass': true, // Agents can skip validation
 *   },
 * };
 *
 * // Naming convention: resource.action
 * // Examples:
 * //   claim.view, claim.create, claim.update, claim.delete
 * //   order.view, order.cancel
 * //   customer.view, customer.edit
 * //   validation.bypass
 */
export const DEFAULT_PERMISSIONS: Record<UserType, Permissions> = {
  customer: {},
  agent: {
    'item.override': true, // Agents can override ineligible items to proceed with claims
  },
};

/**
 * Get default permissions for a given user type.
 */
export const getDefaultPermissions = (userType: UserType): Permissions => {
  return DEFAULT_PERMISSIONS[userType];
};
